import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transferInventoryList: [],
  loading: false,
  error: null,
};

const transferInventorySlice = createSlice({
  name: "GetAllTransferInventory",
  initialState,
  reducers: {
    fetchTransferInventoryStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchTransferInventorySuccess: (state, action) => {
      state.loading = false;
      state.transferInventoryList = action.payload;
    },

    fetchTransferInventoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchTransferInventoryStart,
  fetchTransferInventorySuccess,
  fetchTransferInventoryFailure,
} = transferInventorySlice.actions;

export default transferInventorySlice.reducer;